import React, {Fragment} from "react";
import isEqual from "lodash-es/isEqual";
import Modal from "../../../layout/Modal";
import ComponentConfig from "../../../form/ComponentConfig";
import SelectorGrid from "../../../form/SelectorGrid/SelectorGrid";
import {CurrencyFormatter} from "../../../../utils/formatters";
import Select from "../../../form/Select";
import Icon from "../../../form/Icon";

export const VoucherList = (topProps) => <ComponentConfig componentName="Voucher">{
    (props) => {
        const filterable = true;
        const {componentConfig} = props;
        const {vouchers, onSelectionChange} = topProps;
        const filter = vouchers.length ? [{field: "id", value: vouchers.map((voucher) => voucher.id || voucher.component_id), operator: "in"}] : [{field: "id", operator: "isnull"}];
        filter.push({field: "used", operator: "isnull"});
        filter.push({field: "sold", operator: "not isnull"});
        return <Fragment>
            <SelectorGrid
                component="Voucher"
                className="p-small-table"
                view={[componentConfig.idfield, "vat"]}
                addRow={<Select
                    storeType="remote"
                    component={componentConfig.componentname}
                    placeholder="Utalvány vonalkód"
                    objectValue={true}
                    valueKey="id"
                    labelKey="barcode"
                    label={false}
                    autoSelect={true}
                    openIfHasOptions={true}
                    view={["amount"]}
                    filter={[{field: "sold", operator: "not isnull"},{field: "used", operator: "isnull"}]}
                    saveChanges={(field, value) => {
                        const values = JSON.parse(JSON.stringify(vouchers));
                        if (!values.find((voucher) => value.id + "" === "" + voucher.id)) {
                            values.push(value);
                        }
                        onSelectionChange({value: values});
                    }}
                />}
                columns={{
                    "barcode": {
                        header: 'Vonalkód',
                        width: 10,
                        filterable
                    },
                    "amount": {
                        header: 'Érték',
                        width: 1,
                        filterable,
                        renderer: CurrencyFormatter,
                        className: "currency"
                    },
                    "actions": {
                        header: " ",
                        width: 1,
                        renderer:
                            (value, rowData) => {
                                return <div>
                                <span className={"btn btn-danger btn-xs"} onClick={(e) => {
                                    e && e.preventDefault();
                                    const values = JSON.parse(JSON.stringify(vouchers));
                                    const index = values.findIndex((voucher) => rowData.id + "" === "" + voucher.id);
                                    if (index !== -1) {
                                        values.splice(index, 1);
                                    }
                                    onSelectionChange({value: values});
                                }}><Icon lib="fa" name="trash"/></span>
                                </div>;
                            }
                    }
                }}
                selectionMode="none"
                onSelectionChange={onSelectionChange}
                filter={filter}
            />
        </Fragment>;
    }
}</ComponentConfig>;

export default class VoucherPayment extends React.Component {

    state = {
        vouchers: []
    }

    focus = () => {
        if (!isEqual(this.props.selection || [], this.state.vouchers)) {
            this.setState({vouchers: this.props.selection || []});
        }
        this.modal && this.modal.focus();
    }

    hide = () => {
        this.modal && this.modal.hide();
    }

    onSelectionChange = (e) => {
        const vouchers = JSON.parse(JSON.stringify(e.value || []));
        this.setState({vouchers});
        return true;
    }

    render() {
        return (
            <Modal header="Utalvány kiválasztás" ref={(el) => this.modal = el} size={"large"} {...this.props} disabled={this.props.disabled || this.props.isLoading} buttons={[
                {
                    text: "Mégse",
                    props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                    onClose: true,
                    onClick: async () => {
                        try {
                            this.hide();
                        } catch (e) {

                        }
                    }
                },
                {
                    text: "Kiválasztás",
                    props: {color: "primary", disabled: this.props.disabled || this.props.isLoading},
                    onClick: async () => {
                        try {
                            let vouchers = JSON.parse(JSON.stringify(this.state.vouchers));
                            this.props.setSelected && this.props.setSelected(vouchers);
                            this.hide();
                        } catch (e) {

                        }
                    }
                }
            ]}>
                <VoucherList vouchers={this.state.vouchers} onSelectionChange={this.onSelectionChange} />
            </Modal>
        );
    }
}